var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatSappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.668,
    height: 50.679,
    viewBox: "0 0 50.668 50.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WatSapp",
    transform: "translate(-269.053 -143.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WatSapp-2",
    "data-name": "WatSapp",
    transform: "translate(269.053 143.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10217",
    "data-name": "Group 10217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10216",
    "data-name": "Group 10216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10215",
    "data-name": "Group 10215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27581",
    "data-name": "Path 27581",
    d: "M50.656,24.059A24.879,24.879,0,0,0,.944,23.6c-.013.361-.025.721-.025,1.083A24.494,24.494,0,0,0,4.484,37.438L0,50.679,13.777,46.3A24.906,24.906,0,0,0,50.668,24.687C50.668,24.477,50.668,24.269,50.656,24.059ZM25.794,45.439A20.838,20.838,0,0,1,14.288,42L6.255,44.565l2.607-7.708A20.546,20.546,0,0,1,4.88,24.688a19.233,19.233,0,0,1,.1-2.015,20.922,20.922,0,0,1,41.653.4c.047.536.071,1.071.071,1.619A20.857,20.857,0,0,1,25.794,45.439Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27582",
    "data-name": "Path 27582",
    d: "M133.223,126.763c-.5,1.421-2.992,2.783-4.11,2.877s-1.119.909-7.325-1.5c-6.2-2.432-10.108-8.745-10.411-9.14a13.759,13.759,0,0,1-2.178-4.192,7.745,7.745,0,0,1-.314-2.062,6.776,6.776,0,0,1,2.132-5.054,2.257,2.257,0,0,1,1.63-.757c.408,0,.814.059,1.165.059s.872-.21,1.373,1,1.735,4.193,1.886,4.5a1.091,1.091,0,0,1,.047,1.061,7.017,7.017,0,0,1-.384.721c-.07.093-.139.186-.222.291-.314.35-.64.781-.92,1.06-.3.3-.617.629-.268,1.235a18.088,18.088,0,0,0,3.388,4.181,16.53,16.53,0,0,0,4.9,3c.617.3.967.256,1.328-.152s1.526-1.758,1.932-2.363.815-.513,1.375-.3,3.552,1.665,4.169,1.967,1.012.456,1.164.7a4.983,4.983,0,0,1-.361,2.876",
    transform: "translate(-95.226 -93.518)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatSappIcon);
export default __webpack_public_path__ + "static/media/WatSapp-icon.a1f1582d382941d089e19aacd9259c32.svg";
export { ForwardRef as ReactComponent };